import * as React from 'react';
import { bool, object, string } from 'prop-types';

import styles from './PageLoader.module.scss';

const commonSpinnerAttributes = {
  strokeWidth: '2',
  fill: 'transparent',
  cx: '20',
  cy: '20',
  get r() {
    return Number(this.cy) - Number(this.strokeWidth) / 2;
  }
};

const PageLoader = ({
  color = '#05C3DE',
  className = '',
  height = '120',
  isVisible = false,
  spinnerConfig = {},
  width = '120'
}) =>
  isVisible ? (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40">
      <circle
        stroke="#D6D6D5"
        {...spinnerConfig}
        {...commonSpinnerAttributes}
      />
      <circle
        className={styles['loading-spinner']}
        stroke={color}
        strokeDasharray="25, 100"
        {...spinnerConfig}
        {...commonSpinnerAttributes}
      />
    </svg>
  ) : null;

PageLoader.propTypes = {
  color: string,
  width: string,
  height: string,
  isVisible: bool,
  spinnerConfig: object
};

export default PageLoader;
